import React from 'react'
import {useNavigate} from 'react-router-dom'
import Heading from '../../../atoms/FormHeading';
import { useEffect } from 'react';

import Form from './Form';
import FormHeading from '../../../atoms/FormHeading';

const Login = () => {
    const navigate = useNavigate();
    // Back btn Handling ---------------------------------------------------------------------------------------------
    const onButtonEvent = (e) => {
      e.preventDefault();
      navigate(0);
    };
  
    useEffect(() => {
      window.history.pushState(null, '', window.location.pathname);
      window.addEventListener("popstate", onButtonEvent);
      return () => {
        window.removeEventListener("popstate", onButtonEvent);
      };
    }, []);
    // --------------------------------------------------------------------------------------------------------------
  
    return (
      <>
        <FormHeading title={'Hi, Welcome Back!'} description={'Login to your account to enjoy'} calledForm='auth'/>
        <Form />
      </>
    );
}

export default Login